export const MAX_HEARTS = 3;
export const GRACE_SECONDS = 1.5;
export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
export function freshRound() {
  return {
    status: 'playing',
    score: 0,
    hearts: MAX_HEARTS,
    elapsed: 0,
    graceUntil: 0,
    spawned: 0,
    lastDogAt: -100,
    reaction: { frame: 'normal', until: 0 },
  };
}
export function pace(seconds) {
  const t = clamp(seconds / 150, 0, 1);
  return { fallSpeed: 96 + 55 * t, spawnInterval: 1.5 - 0.38 * t, dogChance: 0.16 + 0.06 * t };
}
export function collect(round, kind) {
  if (round.status !== 'playing') return 'ignored';
  if (kind === 'cat') {
    round.score++;
    round.reaction = { frame: 'happy', until: round.elapsed + 0.85 };
    return 'cat';
  }
  if (kind !== 'dog' || round.elapsed < round.graceUntil) return 'ignored';
  round.hearts = Math.max(0, round.hearts - 1);
  round.graceUntil = round.elapsed + GRACE_SECONDS;
  round.reaction = { frame: 'sad', until: round.elapsed + 1.15 };
  if (round.hearts === 0) {
    round.status = 'ended';
    return 'ended';
  }
  return 'dog';
}
export function expressionAt(round) {
  if (round.status === 'ended') return 'sad';
  return round.elapsed < round.reaction.until ? round.reaction.frame : 'normal';
}
export function chooseKind(round, random = Math.random) {
  const allowDog =
    round.spawned >= 5 && round.elapsed >= 8 && round.elapsed - round.lastDogAt > 4.5;
  const kind = allowDog && random() < pace(round.elapsed).dogChance ? 'dog' : 'cat';
  round.spawned++;
  if (kind === 'dog') round.lastDogAt = round.elapsed;
  return kind;
}
// Swept crossing detects a basket catch even if a slow frame steps over its rim.
export function crossesBasket(
  oldY,
  newY,
  radius,
  oldX,
  newX,
  oldBasketX,
  newBasketX,
  rimY,
  halfWidth,
) {
  const from = oldY + radius,
    to = newY + radius;
  if (from > rimY || to < rimY || to <= from) return false;
  const t = (rimY - from) / (to - from);
  const x = oldX + (newX - oldX) * t;
  const basketX = oldBasketX + (newBasketX - oldBasketX) * t;
  return Math.abs(x - basketX) <= halfWidth + radius * 0.48;
}
